


















































































































































































































































































































































































































// import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwDatetimePicker, DateTimePickerConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import  { MswApiService } from '@/shared/msw-api-service';
import { ProductServicesAvailable, ProductService, ProductFlavour, ProductFlavourService, CasbAppList, ProductFlavourRegion, AnotherProductObjectModalType, RegisteredProductService } from '../types';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { InfoState /* , SetHelpContentIdPayload */ } from '@/core/core.store';
import RegexValidators from '@/shared/regex-validators';
import TzNSAProduct from './tz-nsa-products-modal.vue';
// import { currentUserKey } from '@/shared/msw-constants';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwStatusFlag } from '@libs-uuif/shared/sw-status-flag';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { Mutation } from 'vuex-class';
import { SetAnotherProductModalObjectPayload, SetNewProductModalObjectPayload } from '../msw-tenant-management.store';
// import { productAvailableList } from '../productAvailableServicesList.data';

const cssPrefix = 'another-modal';
const regexValidChars = /^[a-z0-9-]+$/;
const regexStartsWithLetter = /^[a-z]/;
const regexLength = /^.{4,30}$/;

@Component({
  components: {
    ...UUIFComponents,
    SwIconButton,
    SwIcon,
    SwDatetimePicker,
    TzNSAProduct,
    SwCheckbox,
    SwStatusFlag,
  },
})
export default class AnotherProduct extends SwExtendedVue {
  @Mutation
  readonly setNewProductModalObject: VuexMappedMutation<SetNewProductModalObjectPayload>;
  @Mutation
  readonly setAnotherProductModalObject: VuexMappedMutation<SetAnotherProductModalObjectPayload>;
  @Prop({ type: Number })
  selectedkey: number;

  @Prop({ type: String })
  modalType: string;

  @Prop({ type: Boolean })
  enableApiCall: boolean;

  @Prop({ default: false })
  editAlowed: boolean;

  @Prop({ default: false })
  changed: boolean;

  @Prop({ default: '' })
  todayDate: string;

  @Prop({ type: String, default: '' })
  productRegion: string;

  @Prop({ type: Boolean })
  checkForMasterMsspRole: boolean;

  showSubdomain: string;
  showFriendlyName: string;
  todaysDate:string = '';
  orgIdText:string = '';
  acceptProvision:boolean = false;
  sseSubdomainError: string = '';

  get getShowErrMsg() {
    const errorFlag = this.$store.getters['TenantManagementStoreModule/getProductModalFurtherValidation'];
    return errorFlag;
  }

  get checkForCAP() {
    const val = this.productOptions.filter((ele: any) => ele.id === this.anotherProductModalObject.productName)[0].value;
    if (val === '402') return true;
  }

  get checkForSw() {
    const val = this.productOptions.filter((ele: any) => ele.id === this.anotherProductModalObject.productName)[0].value;
    if (val === '411') return true;
  }

  get checkForHES() {
    const val = this.productOptions.filter((ele: any) => ele.id === this.anotherProductModalObject.productName)[0].value;
    if (val === '300') return true;
  }

  get checkForSMA() {
    const val = this.productOptions.filter((ele: any) => ele.id === this.anotherProductModalObject.productName)[0].value;
    if (val === '6383') return true;
  }

  @Watch('changed')
  msspTenantChanged() {
    if (this.changed) {
      this.anotherProductModalObject.productName = '';
      this.isTzSlected = '';
      this.getexistingAppliances = false;
    }
  }
  cssPrefix = cssPrefix;
  productOptions: SelectOption[] = [];
  serviceOptions: SelectOption[] = [];
  regionOptions: SelectOption[] = [];
  singlePickerConfig: DateTimePickerConfig = {
    placeholder: String(this.$t('tenantMgmt.provision.placeholders.sDate')),
    dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick2,
    selectableDatesRange: { startDate: (this.todaysDate.slice(4, 6)).concat('/', this.todaysDate.slice(6), '/', this.todaysDate.slice(0, 4)) },
    hidePreAndNextMonthDates: true,
  };
  productSelectDisabled: boolean = false;
  products:any = {};
  request: any = {};
  productServicesList: ProductService[] = [];
  platformOptions: SelectOption[] = [];
  friendlyName: string = '';
  showRegion:string = 'NO';
  showHA: boolean = false;
  showUpperLimit: string = 'NO';
  showUnits: boolean = false;
  invalidSubDomain: boolean = false;
  minCount: any = 0;
  maxCount: any = 0;
  editFriendName = false;
  fName = '';
  isNsv: boolean = false;
  applicationOption: SelectOption[] = [];
  anotherProductModalObject: AnotherProductObjectModalType = {
    productName: '',
    serviceName: '',
    unitSelected: 'setUpperLimit',
    upperLimit: '',
    dateSelected: '',
    expiryType: 'Never',
    regionSelected: '-1',
    subDomain: '',
    OganizationIDValue: '',
    platformName: '',
    productId: '',
    applicationName: '',
    friendlyName: '',
    showFriendlyName: 'NO',
    friendlyNameBaseText: '',
    showUnits: false,
    showSubDomainName: false,
    showPlatFormOptions: false,
    showOrganizationId: false,
    showApplicationOption: false,
    regionName: '',
    showRegion: false,
    showHA: false,
    isServiceTypechangeAllowed: false,
  };
  registeredProductServices: RegisteredProductService[] = [];
  oldTenantId = '';
  isTzSlected: string = '';
  getexistingAppliances: boolean = false;
  prodId: string = '';
  prodChanged: boolean = false;
  orgIdTooltip: string = '';
  showLic: boolean = false;
  expiry: boolean = false;
  canShowDc: boolean = false;
  lic: boolean = false;
  // get checkForMsspNsm() {
  //   const tempObj: any = localStorage.getItem(currentUserKey);
  //   const userInfoObtained: any = JSON.parse(tempObj);
  //   if (userInfoObtained.roles && userInfoObtained.roles.includes('MSSPNSM')) {
  //     return true;
  //   }
  //   return false;
  // }
  showDc() {
    this.canShowDc = true;
  }
  showLicense() {
    this.lic = true;
  }
  onClickAccept() {
    this.$store.commit('TenantManagementStoreModule/setTzProvision', { tzProvision: this.acceptProvision });
    this.$emit('onAccept', this.request, false, this.expiry, false, {});
  }
  validateSubDomain(value: any) {
    const regexStr =  new RegExp(RegexValidators.subdomain);
    this.invalidSubDomain = !regexStr.test(this.anotherProductModalObject.subDomain);
    this.anotherProductModalObject.friendlyName = value;
    this.updateProductState();
  }
  validateCseName() {
    this.sseSubdomainError = '';

    if (!regexStartsWithLetter.test(this.anotherProductModalObject.subDomain)) {
      this.invalidSubDomain = true;
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameStartsWith')}`;
    } else if (!regexValidChars.test(this.anotherProductModalObject.subDomain)) {
      this.invalidSubDomain = true;
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameInvalid')}`;
    } else if (!regexLength.test(this.anotherProductModalObject.subDomain)) {
      this.invalidSubDomain = true;
      this.sseSubdomainError = `${this.$t('registerProduct.cseNameLengthError')}`;
    }
    this.updateProductState();
  }
  onChangeLimit() {
    this.updateProductState();
  }

  onDayClick2() {
    // @ts-ignore
    this.$refs.expiryDate.outsidePopover = true;
    // @ts-ignore
    this.$refs.expiryDate.$emit('input', this.anotherProductModalObject.dateSelected);
    // console.warn(this.anotherProductModalObject.dateSelected);
  }

  onChangeExpiry() {
    this.updateProductState();
  }

  onRegionSelected() {
    const regionName = this.regionOptions.filter((ele: SelectOption) =>  ele.id === this.anotherProductModalObject.regionSelected);
    this.anotherProductModalObject.regionName = regionName[0] ? regionName[0].label.toString() : '';
    this.updateProductState();
  }
  getRegion() {
    const regionName = this.regionOptions[0].label.toString();
    this.anotherProductModalObject.regionName = regionName;
    this.anotherProductModalObject.regionSelected = this.regionOptions[0].id;
    this.updateProductState();
    return regionName;
  }
  updateProductState() {
    if (this.anotherProductModalObject.upperLimit.length > 5) {
      this.anotherProductModalObject.upperLimit = this.anotherProductModalObject.upperLimit.substring(0, 5);
    }
    const tempProductModalObject = Object.assign({}, {
      productName: this.anotherProductModalObject.productName,
      serviceName: this.anotherProductModalObject.serviceName,
      unitSelected: this.anotherProductModalObject.unitSelected,
      upperLimit: this.anotherProductModalObject.upperLimit,
      dateSelected: this.anotherProductModalObject.dateSelected,
      expiryType: this.anotherProductModalObject.expiryType,
      regionSelected: this.anotherProductModalObject.regionSelected,
      subDomain: this.anotherProductModalObject.subDomain,
      platformName: this.anotherProductModalObject.platformName,
      productId: this.anotherProductModalObject.productId,
      applicationName: this.anotherProductModalObject.applicationName,
      showFriendlyName: this.anotherProductModalObject.showFriendlyName,
      showUnits: this.anotherProductModalObject.showUnits,
      showSubDomainName: this.anotherProductModalObject.showSubDomainName,
      showOrganizationId: this.anotherProductModalObject.showOrganizationId,
      showPlatFormOptions: this.anotherProductModalObject.showPlatFormOptions,
      showApplicationOption: this.anotherProductModalObject.showApplicationOption,
      friendlyName: this.anotherProductModalObject.friendlyName,
      regionName: this.anotherProductModalObject.regionName,
      showRegion: this.anotherProductModalObject.showRegion,
      showHA: this.anotherProductModalObject.showHA,
      isServiceTypechangeAllowed: this.anotherProductModalObject.isServiceTypechangeAllowed,
    });
    this.$store.commit('TenantManagementStoreModule/setAnotherProductModalObject', { productAnotherModalObject: tempProductModalObject });
    // this.setAnotherProductModalObject({ productAnotherModalObject: tempProductModalObject });
  }
  get checkUpperLimit() {
    if (this.anotherProductModalObject.upperLimit === '') {
      return this.$t('tenantMgmt.provision.validations.upperLimitReq');
    }
    if (Number(this.anotherProductModalObject.upperLimit) < this.minCount || Number(this.anotherProductModalObject.upperLimit) > this.maxCount) {
      return String(this.$t('tenantMgmt.provision.validations.validRange'))
      .concat(this.minCount, String(this.$t('tenantMgmt.provision.validations.and')), this.maxCount);
    }
  }
  onPencilCick() {
    this.editFriendName = this.modalType !== 'add' ? true : false; this.fName = this.anotherProductModalObject.friendlyName;
  }
  onTickClick() {
    if (this.anotherProductModalObject.friendlyName.trim().length > 0) {
      this.renameProduct(this.anotherProductModalObject.friendlyName);
      this.$store.commit('TenantManagementStoreModule/setNewProductObjectFriendlyName', { friendlyName: this.anotherProductModalObject.friendlyName });
      this.editFriendName = false;
      // this.editFriendlyName(data, false);
    }
  }
  onCrossClick() {
    this.editFriendName = false;
    this.anotherProductModalObject.friendlyName = this.fName;
    // this.editFriendlyName(data, false);
  }
  onAgree(req: any, isDc: any, showExpiry:boolean , showChildExpiry: boolean, sslVpnObject: Object, unitSelected: string, childUnitSelected: string) {
    this.prodChanged = false;
    this.request = req;
    this.expiry = showExpiry;
    this.$emit('onAccept', req, isDc, showExpiry, showChildExpiry, sslVpnObject, unitSelected, childUnitSelected);
  }
  sslTurnedOf() {
    this.$emit('sslToggleOff');
  }
  renameProduct(data: any) {
    this.$store.commit('startLoading');
    const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const renamelist = [{ serialNumber: productObject.serialNumber, newName: data }];
    this.$store.dispatch(
      'MswProductsStoreModule/renameFriendlyName', { prodsRenamelist: renamelist },
    )
    .then((res) => {
      if (res.msgCode === 'MSWAPP:PRODSRENAMESUCCESS') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.$emit('callTmgmt');
      } else if (res.msgCode === 'MSWAPP:PRODSRENAMEFAILURE') {
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.anotherProductModalObject.friendlyName = this.fName;
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: String(this.$t('tenantMgmt.provision.messages.renameFail')) };
        this.$store.commit('enqueueMessage', message);
        this.anotherProductModalObject.friendlyName = this.fName;
      }
      this.$store.commit('stopLoading');
    });
  }
  onProductSelected() {
    console.warn(this.anotherProductModalObject.productName);
    this.anotherProductModalObject.showApplicationOption = false;
    this.anotherProductModalObject.showFriendlyName = 'NO';
    this.anotherProductModalObject.regionSelected = '-1';

    this.prodChanged = true;
    this.getexistingAppliances = false;
    this.formatServicesOption();
    if (this.anotherProductModalObject.productName !== '') {
      const fetchLabelValue: any = this.productOptions.filter((ele: SelectOption) => ele.id === this.anotherProductModalObject.productName)[0];
      this.showLic = (fetchLabelValue.value.toString()) === '-7' || (fetchLabelValue.value.toString()) === '-8' ? true : false;
      this.isNsv = fetchLabelValue.value.toString() === '-11' || fetchLabelValue.value.toString() === '-12' || fetchLabelValue.value.toString() === '-14'
      || fetchLabelValue.value.toString() === '-17' || fetchLabelValue.value.toString() === '-18' || fetchLabelValue.value.toString() === '-19'
      || fetchLabelValue.value.toString() === '-15' || fetchLabelValue.value.toString() === '-16';
      this.canShowDc = this.showLic ? false : true;
      this.lic = false;
      this.acceptProvision = false;
      const productDetailsFromStore = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      const productDetailsState = productDetailsFromStore.productDetails;
      const currentProduc = JSON.parse(JSON.stringify(productDetailsState));
      const tempData = currentProduc.map((ele: any) => {
        return ele;
      });
      tempData[this.selectedkey - 1].productName = fetchLabelValue ? fetchLabelValue.label : '';
      const tenantObject = this.$store.getters['TenantManagementStoreModule/getCapFName'];
      const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      this.productServicesList.map((ele: ProductService) => {
        if (ele.ProductName === this.anotherProductModalObject.productName)  {
          ele.ProductFlavours.map((productEle: ProductFlavour) => {
            this.anotherProductModalObject.showFriendlyName = productEle.ShowFriendlyName || 'NO';
            this.anotherProductModalObject.showOrganizationId = productEle.ShowOganizationID === 'YES';
            if (this.anotherProductModalObject.showOrganizationId) {
              this.orgIdText = productEle?.OganizationIDText || '';
              this.anotherProductModalObject.subDomain = productEle?.OganizationIDValue || '';
              this.anotherProductModalObject.OganizationIDValue = productEle?.OganizationIDValue || '';
              this.orgIdTooltip = productEle?.OganizationIDToolTip || '';
            }
            this.getexistingAppliances = productEle.getexistingAppliances === 'YES' ? true : false;
            if (this.anotherProductModalObject.showFriendlyName === 'READONLY') {
              this.anotherProductModalObject.friendlyName = productEle?.friendlyNameBaseText ? `${productEle?.friendlyNameBaseText}${tenantObject}`
              : tenantObject !== '' ? `${this.anotherProductModalObject.productName} - ${tenantObject}`
              : `${this.anotherProductModalObject.productName} - ${productObject.tenantName}`;
            } else {
              this.anotherProductModalObject.friendlyName = this.modalType === 'add' ? '' : this.anotherProductModalObject.friendlyName;
            }
          });
        }
      });

      this.isTzSlected = this.productOptions.filter((ele: SelectOption) => ele.id === this.anotherProductModalObject.productName)[0].value
      ?.toString() || '';
      this.$store.commit('TenantManagementStoreModule/setNewProductObjectProductDetail', { productDetails: tempData });
      this.updateProductState();
      this.$emit('onProductSelected');
      if (this.isTzSlected === '-1' || this.isTzSlected === '-7' || this.isTzSlected === '-8') {
        this.$store.commit('TenantManagementStoreModule/setTzProvision', { tzProvision: false });
        this.$emit('onAccept', {}, false);
      }
    } else {
      this.updateProductState();
    }
  }

  onPlatformSelected() {
    this.serviceOptions = [];
    this.regionOptions = [];
    this.applicationOption = [];
    this.anotherProductModalObject.showApplicationOption = false;
    // const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    this.productServicesList.map((ele: ProductService) => {
      if (ele.ProductName === this.anotherProductModalObject.productName)  {
        ele.ProductFlavours.map((productEle: ProductFlavour) => {
          this.anotherProductModalObject.showPlatFormOptions = productEle.Platform !== '';
          if (productEle.Platform === this.anotherProductModalObject.platformName) {
            this.anotherProductModalObject.productId = productEle.ProductID;
            // this.anotherProductModalObject.showFriendlyName = productEle.ShowFriendlyName || 'NO';
            this.anotherProductModalObject.showSubDomainName = productEle.ShowSubDomain === 'YES';
            this.anotherProductModalObject.isServiceTypechangeAllowed = productEle.isServiceTypechangeAllowed === 'YES';
            // if (this.anotherProductModalObject.showFriendlyName === 'READONLY') {
            //   this.anotherProductModalObject.friendlyName = `${this.anotherProductModalObject.productName} - ${productObject.tenantName}`;
            // }
            const tenantObject = this.$store.getters['TenantManagementStoreModule/getCapFName'];
            const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
            if (this.anotherProductModalObject.showFriendlyName === 'READONLY') {
              this.anotherProductModalObject.friendlyName = productEle?.friendlyNameBaseText ? `${productEle?.friendlyNameBaseText}${tenantObject}`
              : tenantObject !== '' ? `${this.anotherProductModalObject.productName} - ${tenantObject}`
              : `${this.anotherProductModalObject.productName} - ${productObject.tenantName}`;
            } else {
              this.anotherProductModalObject.friendlyName = this.modalType === 'add' ? '' : this.anotherProductModalObject.friendlyName;
            }
            productEle.Services.map((servicesEle: ProductFlavourService) => {
              this.anotherProductModalObject.productId = productEle.ProductID;
              let flag = false;
              this.registeredProductServices.map((regEle: RegisteredProductService) => {
                if (regEle.ProductID === this.anotherProductModalObject.productId) {
                  regEle.Services.map((serEle: any) => {
                    if (serEle.ServiceID === servicesEle.ServiceID) {
                      flag = true;
                    }
                  });
                }
              });
              if (!flag && (this.modalType === 'add' && servicesEle.isProvisioningService === 'YES' || this.modalType === 'edit')) {
                this.serviceOptions.push({
                  id: servicesEle.ServiceID,
                  label: servicesEle.ServiceName,
                  value: servicesEle.ServiceID,
                });
              }
              if (productEle.Regions) {
                productEle.Regions.map((regionEle: ProductFlavourRegion) => {
                  this.regionOptions.push({
                    id: regionEle.RegionID,
                    label: regionEle.RegionName,
                    value: regionEle.RegionID,
                  });
                });
              }

            });
          }
        });
      }
    });
    this.updateProductState();
  }

  resetValues() {
    this.anotherProductModalObject.productName = '';
    this.anotherProductModalObject.serviceName = '';
  }

  get getProductNewModalObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
  }

  get getDisabledStateForProduct() {
    const productDetailsFromStore = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    const msspName = productDetailsFromStore.msspName;
    const tenantName = productDetailsFromStore.tenantName;
    // console.warn('chek', msspName, tenantName);
    if ((msspName !== 'mssp' &&  tenantName !== 'tenant')) {
      this.loadAnotherProductApi();
    }
    return !(msspName !== 'mssp' &&  tenantName !== 'tenant');
  }

  onServiceSelected() {
    this.applicationOption = [];
    // const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    this.anotherProductModalObject.showApplicationOption = false;
    this.productServicesList.map((ele: ProductService) => {
      if (ele.ProductName === this.anotherProductModalObject.productName)  {
        ele.ProductFlavours.map((productEle: ProductFlavour) => {
          if (!this.anotherProductModalObject.showPlatFormOptions) {
            this.anotherProductModalObject.productId = productEle.ProductID;
          }
          // this.anotherProductModalObject.showFriendlyName = productEle.ShowFriendlyName || '';
          this.anotherProductModalObject.showSubDomainName = productEle.ShowSubDomain === 'YES';
          // if (this.anotherProductModalObject.showFriendlyName === 'READONLY') {
          //   this.anotherProductModalObject.friendlyName = `${this.anotherProductModalObject.productName} - ${productObject.tenantName}`;
          // } else {
          //   this.anotherProductModalObject.friendlyName = this.modalType === 'add' ? '' : this.anotherProductModalObject.friendlyName;
          // }
          productEle.Services.map((servicesEle: ProductFlavourService) => {
            if (this.anotherProductModalObject.serviceName === servicesEle.ServiceID) {
              this.minCount = servicesEle.minNodeCount;
              this.maxCount = servicesEle.maxNodeCount;
              if (servicesEle.casbAppList) {
                this.anotherProductModalObject.showApplicationOption = true;
                servicesEle.casbAppList.map((appEle: CasbAppList) => {
                  this.applicationOption.push({
                    id: appEle.appValue,
                    label: appEle.appName,
                    value: appEle.appValue,
                  });
                });
              }
            }
          });
        });
      }
    });
    this.updateProductState();
  }

  formatServicesOption() {
    this.serviceOptions = [];
    this.platformOptions = [];
    this.regionOptions = [];
    this.productServicesList.map((ele: ProductService) => {
      if (ele.ProductName === this.anotherProductModalObject.productName)  {
        ele.ProductFlavours.map((productEle: ProductFlavour) => {
          this.showRegion = productEle.ShowRegion || 'NO';
          this.showUnits = productEle.ShowUnits === 'YES';
          this.showHA = productEle.ShowHA === 'YES' ? true : false;
          this.anotherProductModalObject.showUnits = productEle.ShowUnits === 'YES' ? true : false;
          this.anotherProductModalObject.unitSelected = this.showUnits ? 'setUpperLimit' : 'noUpperLimit';
          this.anotherProductModalObject.showRegion = this.showRegion === 'YES' ? true : false;
          this.anotherProductModalObject.isServiceTypechangeAllowed = productEle.isServiceTypechangeAllowed === 'YES';
          this.showHA = productEle.ShowHA === 'YES' ? true : false;
          this.showUpperLimit = productEle.ShowUpperLimit || 'NO';
          this.showSubdomain = productEle.ShowSubDomain || 'NO';
          this.showFriendlyName = productEle.ShowFriendlyName || 'NO';
          this.anotherProductModalObject.showOrganizationId = productEle.ShowOganizationID === 'YES';
          this.orgIdText = productEle?.OganizationIDText || '';
          this.anotherProductModalObject.OganizationIDValue = productEle?.OganizationIDValue || '';
          this.anotherProductModalObject.subDomain = productEle?.OganizationIDValue || '';
          this.orgIdTooltip = productEle?.OganizationIDToolTip || '';
          this.platformOptions.push({
            id: productEle.Platform,
            label: productEle.Platform,
            value: productEle.Platform,
          });
          this.anotherProductModalObject.showPlatFormOptions = productEle.Platform !== '';
          if (!this.anotherProductModalObject.showPlatFormOptions) {
            productEle.Services.map((servicesEle: ProductFlavourService) => {
              this.anotherProductModalObject.productId = productEle.ProductID;
              let flag = false;
              this.registeredProductServices.map((regEle: RegisteredProductService) => {
                if (regEle.ProductID === this.anotherProductModalObject.productId) {
                  regEle.Services.map((serEle: any) => {
                    if (serEle.ServiceID === servicesEle.ServiceID) {
                      flag = true;
                    }
                  });
                }
              });
              if (!flag && (this.modalType === 'add' && servicesEle.isProvisioningService === 'YES' || this.modalType === 'edit')) {
                this.serviceOptions.push({
                  id: servicesEle.ServiceID,
                  label: servicesEle.ServiceName,
                  value: servicesEle.ServiceID,
                });
              }
            });
            if (productEle.Regions) {
              productEle.Regions.map((regionEle: ProductFlavourRegion) => {
                this.regionOptions.push({
                  id: regionEle.RegionID,
                  label: regionEle.RegionName,
                  value: regionEle.RegionID,
                });
              });
            }
          } else {
            this.onPlatformSelected();
          }
        });
      }
    });
    if (this.modalType !== 'add') {
      this.loadEditDetails();
    }
  }

  formatProductOption() {
    const prods: any = [];
    this.productServicesList.map((ele: ProductService) => {
      for (const flavour of ele.ProductFlavours) {
        if (flavour.isProvisioningProduct === 'YES' && !prods.find((obj: any) => obj.id === (ele.ProductName))) { // checking for duplicate values when the length of prods Array is greater than one
          prods.push({
            id: ele.ProductName,
            label: ele.ProductName,
            value: flavour.ProductID,
          });
        }
      }
      return prods;
    });
    this.productOptions = prods;
    if (this.modalType !== 'add') {
      this.loadEditDetails();
    }
  }

  getProductServicesList() {
    const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    return new Promise((res) => {
      this.$store.commit('startLoading');
      MswApiService.tenant.getProductServicesList(productObject.tenantId, productObject.productDetails[0].serviceId, this.modalType === 'add' ? 'PROVISION' : 'EDIT')
      .then((resp: ProductServicesAvailable) => {
        const productObjectId = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
        this.oldTenantId = productObjectId.tenantId;
        this.productServicesList = resp.content ? resp.content.ProductServices : [] || [];
        this.registeredProductServices = resp.content ? resp.content.RegisteredProductServices || [] : [];
        this.formatProductOption();
        this.formatServicesOption();
        this.$store.commit('stopLoading');
        if (this.modalType === 'add') {
          setTimeout(() => {
            // this.$store.commit('stopLoading');
          }, 2000); // tslint:disable-line
        }
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }

  @Watch('enableApiCall')
  async loadAnotherProductApi() {
    try {
      const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
      if (productObject.tenantId !== 'tenant' && this.oldTenantId !== productObject.tenantId) {
        this.oldTenantId = productObject.tenantId;
        await this.getProductServicesList();
        this.$emit('applicableMsspProductServicesApiCompleted');
        // if (this.isTzSlected !== '-1' && this.modalType === 'add') {
        // }
      }
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  fetchService(data: string) {
    const serviceName = data.split(' - ');
    const filteredService = this.serviceOptions.filter((ele: SelectOption) => ele.label === serviceName[1] ? serviceName[1] : '')[0];
    return filteredService ? filteredService.id : '';
  }

  formatDate(data: string) {
    // const bfrFormat = data.split('T')[0];
    const splitDate = data.split('/');
    const formattedDate: string = `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`;
    return formattedDate;
  }
  unitsSelected() {
    const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    if (productObject.productDetails[0].unitSelected === 'noUpperLimit' && this.showUpperLimit === 'YES') {
      return 'noUpperLimit';
    }
    if (productObject.productDetails[0].unitSelected === 'noUpperLimit' && this.showUpperLimit === 'NO') {
      return 'setUpperLimit';
    }
    if (productObject.productDetails[0].unitSelected === 'N/A' && this.showUpperLimit === 'YES') {
      return 'noUpperLimit';
    }
    if (productObject.productDetails[0].unitSelected === 'N/A' && this.showUpperLimit === 'NO') {
      return 'setUpperLimit';
    }
    if (productObject.productDetails[0].unitSelected !== 'N/A' || productObject.productDetails[0].unitSelected !== 'noUpperLimit') {
      return 'setUpperLimit';
    }
  }
  unitsSelectedLimit() {
    const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    if (productObject.productDetails[0].unitSelected === 'noUpperLimit' && this.showUpperLimit === 'YES') {
      return 0;
    }
    if (productObject.productDetails[0].unitSelected === 'noUpperLimit' && this.showUpperLimit === 'NO') {
      return this.minCount.toString();
    }
    if (productObject.productDetails[0].unitSelected === 'N/A' && this.showUpperLimit === 'NO') {
      return this.minCount.toString();
    }
    if (productObject.productDetails[0].unitSelected !== 'N/A' || productObject.productDetails[0].unitSelected !== 'noUpperLimit') {
      return productObject.productDetails[0].unitSelected;
    }
    if (productObject.productDetails[0].unitSelected === 'setUpperLimit') {
      return this.minCount.toString();
    }
  }
  loadEditDetails() {
    const productObject = this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
    this.anotherProductModalObject.productName = productObject.productDetails[0].productName;
    this.anotherProductModalObject.productId = productObject.productDetails[0].productId;
    this.isTzSlected = productObject.productDetails[0].productId;
    this.isNsv = productObject.productDetails[0].productId === '-11' || productObject.productDetails[0].productId === '-12'
     || productObject.productDetails[0].productId === '-14' || productObject.productDetails[0].productId === '-17'
      || productObject.productDetails[0].productId === '-18' || productObject.productDetails[0].productId === '-19'
      || productObject.productDetails[0].productId === '-15' || productObject.productDetails[0].productId === '-16';
    this.anotherProductModalObject.serviceName = (productObject.productDetails[0].serviceId);
    this.productServicesList.map((ele: ProductService) => {
      ele.ProductFlavours.map((productEle: ProductFlavour) => {
        if ((productEle.ProductID === productObject.productDetails[0].productId) ||
      ((productObject.productDetails[0].productId === '27102' || productObject.productDetails[0].productId === '27104' ||
        productObject.productDetails[0].productId === '27121' || productObject.productDetails[0].productId === '28121' ||
        productObject.productDetails[0].productId === '-14' || productObject.productDetails[0].productId === '-15' ||
        productObject.productDetails[0].productId === '-16' || productObject.productDetails[0].productId === '-17' ||
        productObject.productDetails[0].productId === '-18' || productObject.productDetails[0].productId === '-19'
      ) && productEle.ProductID === '-11') || ((productEle.ProductID === '-9') &&
       (productObject.productDetails[0].productId === '-6' || productObject.productDetails[0].productId === '-10' ||
        productObject.productDetails[0].productId === '-1' || productObject.productDetails[0].productId === '-13'
      ))) {
          productEle.Services.map((servicesEle: ProductFlavourService) => {
            this.getexistingAppliances = productEle.getexistingAppliances === 'YES' ? true : false;
            if (this.anotherProductModalObject.serviceName === servicesEle.ServiceID) {
              this.minCount = servicesEle.minNodeCount;
              this.maxCount = servicesEle.maxNodeCount;
            }
          });
        }
      });
    });
    this.anotherProductModalObject.unitSelected = String(this.unitsSelected());
    this.anotherProductModalObject.upperLimit = this.unitsSelectedLimit();
    this.anotherProductModalObject.expiryType = productObject.productDetails[0].expiryType === 'Never' || productObject.productDetails[0].expiryType === 'N/A' ? 'Never' : 'selectExpiry';
    this.anotherProductModalObject.dateSelected = this.anotherProductModalObject.expiryType === 'Never' || productObject.productDetails[0].expiryType === 'N/A' ? '' : productObject.productDetails[0].expiryType;
    this.anotherProductModalObject.regionName = productObject.productDetails[0].region;
    this.anotherProductModalObject.regionSelected = productObject.productDetails[0].region !== '' ? productObject.productDetails[0].region : '-1';
    this.anotherProductModalObject.platformName = productObject.productDetails[0].platform;
    this.anotherProductModalObject.friendlyName = productObject.productDetails[0].friendlyName || '';
    this.anotherProductModalObject.showHA = productObject.productDetails[0].showHA;
    this.updateProductState();
    this.$store.commit('stopLoading');
  }

  created() {
    this.todaysDate = this.todayDate;
    // console.warn(this.todaysDate);
    this.oldTenantId = '';
    this.loadAnotherProductApi();
    this.msspTenantChanged();
    if (this.modalType === 'add') {
      this.editFriendName = true;
    }
    this.prodId = this.modalType === 'add' ? this.anotherProductModalObject.productName : this.anotherProductModalObject.productId;
  }
  makeElipsis(item: string, size:number = 20) {
    if (item.length > size) {
      return `${item.slice(0, size)}...`;
    } return item;
  }
}
